<div class="boxWhite">
    <h4>INICIAR JORNADA</h4>

    <button class="btn btnClose" (click)="close()">
        <img src="assets/img/icoClose.svg" alt="">
    </button>

    <div class="contModal">
        <div class="row">
            <div class="col-sm-6">
                <h6 class="clBlack">ID CB</h6>
                <p class="clGray mb-4">{{jornada?.conductor.visibleId}}</p>
            </div>
            <div class="col-sm-6">
                <h6 class="clBlack">nombre conductor</h6>
                <p class="clGray mb-4">{{jornada?.conductor.nombres}} {{jornada?.conductor.apellidoPaterno}}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6">
                <h6 class="clBlack">Inicio Jornada</h6>
                <p class="clGray mb-4">{{muestraHora(jornada?.fechaInicioPlanificado)}}</p>
            </div>
            <div class="col-sm-6">
                <div class="d-flex align-items-center gap5">
                    <!-- Esto se comento ya qye JP indico q cliente lo mando a quitar
                    <h6 class="clBlack">Iniciar Ahora</h6>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                    </div>-->
                </div>
            </div>
        </div>

        <div class="row" *ngIf="accion == 'PRE_INICIAR'">
            <div class="col-sm-12">
                <div class="boxInsideModal bgLightGray mb-4 d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-center">
                        <h6>Estado Jornada</h6>
                        <p class="clLightBlue m-0 fw-medium">{{jornada?.estado.replace('_', ' ')}}</p>
                    </div>
                </div>
            </div>
        </div>

      <!-- ya no se debe mostrar, confunde a los oepradores
        <div class="row" *ngIf="accion == 'PRE_INICIAR'">
          <div class="col-sm-12">
            <div class="boxInsideModal bgLightGray mb-4 d-flex align-items-center justify-content-between">
              <div class="d-flex flex-column justify-content-center">
                <h6>Estado Conductor</h6>
                <p class="clLightBlue m-0 fw-medium">{{jornada?.conductor.estado.replace('_', ' ')}}</p>
              </div>
            </div>
          </div>
        </div>
        -->

        <div class="row" *ngIf="accion == 'POST_INICIAR'">
            <div class="col-sm-12">
                <div class="boxInsideModal bgGreen mb-4 d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-center">
                        <h6>Estado</h6>
                        <p class="clWhite m-0 fw-medium">JORNADA INICIADA</p>
                    </div>
                    <button class="btn">
                        <div class="bigIcon bgBlack">
                            <img src="assets/img/icoPrint.svg" alt="">
                        </div>
                    </button>
                </div>
            </div>
        </div>

    </div>


    <div class="footModal">
        <button class="btn btnGreen w-100" [disabled]="enviando" (click)="putIniciarJornada()" *ngIf="accion == 'PRE_INICIAR' && tienePermisoIniciarJornada()">
            <span *ngIf="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            INICIAR JORNADA E IMPRIMIR
        </button>
        <button class="btn btnBlack w-100" (click)="close()" *ngIf="accion == 'POST_INICIAR'">SALIR</button>
    </div>


</div>
